import { useNavigate } from "react-router-dom";
import { config } from "../Environment";
import { useEffectOnce } from "../hooks/useEffectOnce";
import useRetryFetch from "../hooks/useRetryFetch";
import { useState, useContext, useEffect } from "react";
import { useTranslation } from "react-i18next";
import LoggerContext from "../context/LoggerProvider";
import useAuth from "../hooks/useAuth";
import { SYSADMIN_ROLE } from "../lib/roles";
import {
  Card,
  CardContent,
  CardDescription,
  CardHeader,
  CardTitle,
} from "./ui/card";
import { PageLoader } from "./ui/page-loader";

function EntryAdmin() {
  const navigate = useNavigate();
  const retryFetch = useRetryFetch();
  const { auth, user } = useAuth();
  const { Logger } = useContext(LoggerContext);
  const { t } = useTranslation();
  const [authenticated, setAuthenticated] = useState(false);

  useEffect(() => {
    if (auth?.email) {
      setAuthenticated(true);
      const roles = user.roles ?? [];
      setTimeout(() => {
        if (roles.includes(SYSADMIN_ROLE)) {
          navigate("/admin");
        } else {
          navigate("/portal");
        }
      }, 1000);
  }
  }, []);

  function renderAuthenticated() {
    return (
        <PageLoader fullScreen />
    );
  }

  function renderNotAuthenticated() {
    return (
    <Card className="center">
          <CardContent side="bottom">
            <CardHeader>
              <CardTitle>You are signed out</CardTitle>
            </CardHeader>
  <p style={{"margin":"5px"}}>Thank you for using ClaryNext.</p>
  <p style={{"margin":"5px"}}><strong>Where to go from here?</strong></p>
  <p style={{"margin":"5px"}}>Sign in to return to the admin dashboard.</p>
  <p style={{"margin":"5px"}}>Visit our website:</p>
  <p style={{"margin":"5px"}}><a href="https://clarynext.com" style={{"color":"blue","textDecoration":"underline"}}>ClaryNext.com</a></p>
          </CardContent>
        </Card>
    );
  }

  if (authenticated) {
    return renderAuthenticated();
  } else {
    return renderNotAuthenticated();
  }

}

export default EntryAdmin;
